var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8918 0.944551C25.1085 1.39283 25.9168 2.55206 25.9168 3.84876V22.1529C25.9168 23.4496 25.1085 24.6088 23.8918 25.0571C22.2405 25.6655 20.4265 25.6655 18.7752 25.0571C17.5585 24.6088 16.7502 23.4496 16.7502 22.1529L16.7502 3.84876C16.7502 2.55206 17.5585 1.39283 18.7752 0.94455C20.4265 0.336191 22.2405 0.336192 23.8918 0.944551ZM23.4168 3.84876C23.4168 3.59946 23.2614 3.37659 23.0275 3.29041C21.9341 2.88757 20.7329 2.88757 19.6395 3.29041C19.4056 3.37659 19.2502 3.59946 19.2502 3.84876L19.2502 22.1529C19.2502 22.4022 19.4056 22.6251 19.6395 22.7113C20.7329 23.1141 21.9341 23.1141 23.0275 22.7113C23.2614 22.6251 23.4168 22.4022 23.4168 22.1529V3.84876Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2251 0.944551C8.44184 1.39283 9.25016 2.55206 9.25016 3.84876L9.25016 22.1529C9.25016 23.4496 8.44184 24.6088 7.2251 25.0571C5.57384 25.6655 3.75982 25.6655 2.10856 25.0571C0.891816 24.6088 0.083496 23.4496 0.0834961 22.1529L0.083497 3.84876C0.0834971 2.55206 0.891815 1.39283 2.10857 0.94455C3.75982 0.336191 5.57384 0.336192 7.2251 0.944551ZM6.75016 3.84876C6.75016 3.59946 6.59476 3.37659 6.36083 3.29041C5.26742 2.88757 4.06624 2.88757 2.97283 3.29041C2.7389 3.37659 2.5835 3.59946 2.5835 3.84876L2.5835 22.1529C2.5835 22.4022 2.7389 22.6251 2.97283 22.7113C4.06624 23.1141 5.26742 23.1141 6.36083 22.7113C6.59476 22.6251 6.75016 22.4022 6.75016 22.1529L6.75016 3.84876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.05dbde982f4b3e2809d0bd8243a74bba.svg";
export { ForwardRef as ReactComponent };